<!-- eslint-disable -->
<template>
  <div class='c25_template'>
    <div>
      <h1>Web-Based AV Control System</h1>
      <div class="c25_inner_template">
        <img src="https://picsum.photos/id/2/500/400">
        <div class="c25_features">
          <p>On Site / Mobile / Remote</p>
          <p>Full Control of Your Teleconferencing System</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "cLandingHeader"
};
</script>



// WEBPACK FOOTER //
// src/components/public/c25LandingPage.vue